import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { CalendarFruitType } from './calendar.model';

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  private readonly http = inject(HttpClient);

  getFruitTypes() {
    return this.http.get<CalendarFruitType[]>(
      `${environment.apiUrl}/fruit-types`,
    );
  }
}
